import { useState, useEffect, useContext } from 'react';
import {
  DexTradeStatus,
  OpenPositionListItem,
} from 'api/types/httpsTypes/dex-trade';
import { useUser } from 'modules/user/user';
import { Chains } from 'api/types/httpsTypes/d-wallets';
import { WebSocketContext } from 'api/services/websocket/websocketProvider';

interface PositionUpdateMessage {
  u: number;
  f: DexTradeStatus;
  p: OpenPositionListItem;
}

export const usePositionUpdate = (
  chain: Chains,
  noChainCheck?: boolean
): PositionUpdateMessage | null => {
  const wsContext = useContext(WebSocketContext);
  const [position, setPosition] = useState<PositionUpdateMessage | null>(null);
  const user = useUser();

  useEffect(() => {
    if (!wsContext || !user?.id) return;

    const dataKey = { positionType: 'open' };
    const cached = wsContext.getLatestMessage('position_update', dataKey);

    if (cached?.data) {
      const parsed = cached.data as PositionUpdateMessage;
      if ((parsed.p.chain === chain || noChainCheck) && parsed.u === user.id) {
        setPosition(parsed);
      }
    }

    const handleMessage = (msg: any) => {
      try {
        const parsed: PositionUpdateMessage = msg.data;

        if (
          (parsed.p.chain !== chain && !noChainCheck) ||
          parsed.u !== user.id
        ) {
          return;
        }

        setPosition(parsed);
      } catch (err) {
        console.error('❌ Error parsing position update message:', err);
      }
    };

    wsContext.addMessageListener('position_update', dataKey, handleMessage);
    return () => {
      wsContext.removeMessageListener(
        'position_update',
        dataKey,
        handleMessage
      );
    };
  }, [wsContext, chain, noChainCheck, user?.id]);

  return position;
};
